export interface IStreakStats {
    id: number;
    currentStreak: number;
    longestStreak: number;
    totalLessons: number;
    lessonsCompletedToday: number;
    dailyGoal: number;
    dailyGoalReached: boolean;
}

export interface IStreakPeriod {
    Id: number;
    StudentID: number;
    LessonsCount: number;
    StartDate: string;
    EndDate: string;
}

export enum StreakType {
    DONE = "DONE",
    BROKEN = "BROKEN",
    TODAY = "TODAY",
    DEFAULT = "DEFAULT"
}

/** Sunday-first two-letter labels used as i18n keys in streak widgets. */
export const WEEKDAY_ABBREVIATIONS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"] as const;

export interface IWeekDay {
    date: Date;
    label: string;
    status: StreakType;
}

export type WidgetType = "small" | "big";
